import * as React from 'react';
import PageInfo from '../../../common/PageInfo/PageInfo';

import todaykz from '../../../../images/partners/today-kz.svg';
import belnovosti from '../../../../images/partners/belnovosti.svg';
import wallstreet from '../../../../images/partners/wall-street.svg';
import forbes from '../../../../images/partners/forbes.svg';
import milligazete from '../../../../images/partners/milligazete.svg';
import ziare from '../../../../images/partners/ziare.svg';

import * as styles from './Partners.module.scss';

const Partners = () => (
  <section className={styles.root}>
    <div className={styles.containerWrapper}>
      <div className={styles.infoContainer}>
        <div className={styles.titleBlock}>
          <div className={styles.title}>
            Our media
            <br />
            partners
          </div>
          <div className={styles.divider} />
        </div>
        <div className={styles.content}>
          <div className={styles.grid}>
            <div className={styles.gridItem}>
              <img alt="Today.kz" src={todaykz} className={styles.gridImg} />
            </div>
            <div className={styles.gridItem}>
              <img alt="Белновости" src={belnovosti} className={styles.gridImg} />
            </div>
            <div className={styles.gridItem}>
              <img alt="WALL-STREET" src={wallstreet} className={styles.gridImg} />
            </div>
            <div className={styles.gridItem}>
              <img alt="Forbes" src={forbes} className={styles.gridImg} />
            </div>
            <div className={styles.gridItem}>
              <img alt="MILLIGazete" src={milligazete} className={styles.gridImg} />
            </div>
            <div className={styles.gridItem}>
              <img alt="Ziare.com" src={ziare} className={styles.gridImg} />
            </div>
          </div>
        </div>
      </div>
      <PageInfo text={'07 - partners'} />
    </div>
  </section>
);

export default Partners;
